import { render, staticRenderFns } from "./Inteface.vue?vue&type=template&id=2a774a83&scoped=true&"
import script from "./Inteface.vue?vue&type=script&lang=js&"
export * from "./Inteface.vue?vue&type=script&lang=js&"
import style0 from "./Inteface.vue?vue&type=style&index=0&id=2a774a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a774a83",
  null
  
)

export default component.exports